<template>
  <el-dialog
    title="修改企业"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
        <div class="common-form">修改企业</div>

        <el-form-item label="企业名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入企业名称" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="企业bannar：" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.bannar">
              <transition-group>
                <div v-for="(item, index) in form.bannar" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bannar')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('bannar')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="企业图片：" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.image">
              <transition-group>
                <div v-for="(item, index) in form.image" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'album')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('album')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="企业视频：">
          <div class="video-upload-container">
            <video 
              v-if="form.video" 
              :src="form.video" 
              controls 
              class="video-preview"
            ></video>
            
            <el-upload
              class="video-upload"
              action=""
              :show-file-list="false"
              :before-upload="beforeVideoUpload"
              :http-request="uploadVideo"
              accept="video/*"
            >
              <el-button size="small" type="primary">
                <i class="el-icon-upload"></i> 上传视频
              </el-button>
              <div slot="tip" class="el-upload__tip">
                支持mp4、avi等视频格式，建议大小不超过50MB
              </div>
            </el-upload>
            
            <el-button 
              v-if="form.video"
              size="small" 
              type="danger" 
              @click="removeVideo"
              class="video-delete-btn"
            >
              删除视频
            </el-button>
          </div>
        </el-form-item>

        <el-form-item label="企业介绍">
          <div class="edit_container">
            <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
          </div>
        </el-form-item>  

        <!-- Contact Information -->
        <el-form-item label="联系电话">
          <el-input v-model="form.phone" placeholder="请输入联系电话" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="联系邮箱">
          <el-input v-model="form.email" placeholder="请输入联系邮箱" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="联系地址">
          <el-input v-model="form.address" placeholder="请输入联系地址" class="max-w460"></el-input>
        </el-form-item>

        <!-- Qualifications -->
        <el-form-item label="企业资质">
          <div class="qualifications-list">
            <div v-for="(qualification, index) in form.qualifications" :key="index" class="qualification-item">
              <div class="qualification-image">
                <img v-img-url="qualification.image" alt="资质图片"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteQualification(index)">
                  <i class="el-icon-close"></i>
                </a>
              </div>
              <el-input 
                v-model="qualification.name" 
                placeholder="资质名称" 
                class="qualification-address"
              ></el-input>
            </div>
            
            <div class="add-qualification" @click="addQualification">
              <i class="el-icon-plus"></i>
              <span>添加资质</span>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="排序" prop="name">
          <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
        </el-form-item>
       
        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      
      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
    </div>
  </el-dialog>
</template>

<script>
import SettledApi from '@/api/settled.js';
import FileApi from '@/api/file.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';

export default {
  components: {
    Upload,
    draggable,
    Uediter
  },
  data() {
    return {
      isupload: false,
      isImg: false,
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      form: {
        name: '',
        code: 'custom',
        image: [],
        video: null,
        sort: 50,
        intro: "",
        bannar: [],
         phone: '',
          email: '',
          address: '',
        qualifications: []
      },
      loading: false,
      rules: {
        name: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
      },
      dialogVisible: false,
      isProductUpload: false,
      code: "album"
    };
  },
  props: ["open_add", "enterprise_id"],
  watch: {
    open_add(val) {
      this.dialogVisible = val;
      if (val) {
        this.getDetail();
      }
    }
  },
  methods: {
    beforeVideoUpload(file) {
      const isVideo = /\.(mp4|avi|mov|wmv|flv|mkv)$/i.test(file.name);
      const isLt50M = file.size / 1024 / 1024 < 50;

      if (!isVideo) {
        this.$message.error('请上传视频文件 (MP4/AVI/MOV/WMV/FLV/MKV)！');
        return false;
      }
      if (!isLt50M) {
        this.$message.error('视频大小不能超过50MB！');
        return false;
      }

      const invalidChars = /[<>:"\/\\|?*\x00-\x1F]/g;
      if (invalidChars.test(file.name)) {
        this.$message.error('文件名包含非法字符，请重命名后上传！');
        return false;
      }

      return true;
    },

    uploadVideo(param) {
      const loading = this.$loading({
        lock: true,
        text: '视频上传中,请等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      const formData = new FormData();
      formData.append('iFile', param.file);

      FileApi.uploadFile(formData)
        .then(response => {
          loading.close();
          this.form.video = response.data.file_path;
          this.$message.success('视频上传成功！');
        })
        .catch(error => {
          loading.close();
          console.error('上传失败:', error);
          this.$message.error('视频上传失败，请检查文件格式或网络！');
        });
    },

    removeVideo() {
      this.form.video = null;
    },

    dialogFormVisible(result) {
      this.$emit("close", {});
    },

    cancelFunc() {
      this.dialogFormVisible("error");
    },

    getDetail() {
      let self = this;
      SettledApi.detail({enterprise_id: self.enterprise_id}, true)
        .then(res => {
          self.form = {
            ...res.data,
            contact: res.data.contact || { phone: '', email: '', address: '' },
            qualifications: res.data.qualifications || [],
            bannar: res.data.bannar || [],
            image: res.data.image || []
          };
          self.ueditor.text = self.form.intro;
          self.isImg = true;
          self.loading = false;
          
          if (res.data.video) {
            self.form.video = res.data.video;
          }
        })
        .catch(error => {
          console.error(error);
        });
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      
      if(form.image.length <= 0) {
        self.$message({
          message: "请上传图片",
          type: 'error'
        });
        return;
      }
      
      form.enterprise_id = self.enterprise_id;
      form.intro = this.$refs.ue.getUEContent();
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          SettledApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    openProductUpload(code) {
      this.isProductUpload = true;
      this.code = code;
    },

    returnProductImgsFunc(e) {
      if (this.code.startsWith('qualification_')) {
        const index = parseInt(this.code.split('_')[1]);
        if (e && e[0]) {
          if (!this.form.qualifications[index]) {
            this.$set(this.form.qualifications, index, { image: '', name: '' });
          }
          this.$set(this.form.qualifications[index], 'image', e[0].file_path);
        }
      } 
      else if (this.code == 'album') {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      }
      else if (this.code == 'bannar') {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }
      
      this.isProductUpload = false;
    },

    deleteImg(index, code) {
      if (code == 'album') {
        this.form.image.splice(index, 1);
      } else if (code == 'bannar') {
        this.form.bannar.splice(index, 1);
      }
    },

    addQualification() {
      if (!this.form.qualifications) {
        this.$set(this.form, 'qualifications', []);
      }
      
      this.form.qualifications.push({
        image: '',
        name: ''
      });
      
      this.code = 'qualification_' + (this.form.qualifications.length - 1);
      this.isProductUpload = true;
    },

    deleteQualification(index) {
      this.form.qualifications.splice(index, 1);
    }
  },
  created() {
    this.dialogVisible = this.open_add;
    if (this.open_add) {
      this.getDetail();
    }
  }
};
</script>

<style scoped>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.video-upload-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.video-preview {
  width: 100%;
  max-height: 300px;
  background-color: #000;
  border-radius: 4px;
  margin-bottom: 10px;
}

.video-upload {
  display: inline-block;
}

.video-delete-btn {
  margin-left: 10px;
}

.el-upload__tip {
  font-size: 12px;
  color: #909399;
  margin-top: 7px;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.qualifications-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.qualification-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.qualification-image {
  position: relative;
  width: 110px;
  height: 110px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.qualification-image img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.qualification-address {
  flex: 1;
}

.add-qualification {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 110px;
  height: 40px;
  border: 1px dashed #ddd;
  border-radius: 4px;
  cursor: pointer;
  color: #409eff;
}

.add-qualification:hover {
  border-color: #409eff;
}

.delete-btn {
  cursor: pointer;
}

.max-w460 {
  max-width: 460px;
}

.pb50 {
  padding-bottom: 50px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/enterprise/settled/part/edit.vue